import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/img/Warning.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "100",
  height: "100",
  alt: "Alerta"
}, null, -1)
const _hoisted_2 = { class: "popUpDD" }
const _hoisted_3 = {
  key: 0,
  class: "txtPopUpDD"
}
const _hoisted_4 = {
  key: 1,
  class: "txtPopUpDD"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 2,
  class: "txtPopUpDD"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "Aportes en Línea", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Nómina Electrónica", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, "nominaelectronica@aportesenlinea.com", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: true,
    modal: "",
    closable: false,
    header: "Importante",
    draggable: false,
    id: "p-dialog"
  }, {
    footer: _withCtx(() => [
      (!$setup.sinSalidaDePlans)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            icon: "pi pi-times",
            onClick: $setup.CerrarModal,
            text: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("← Volver")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_row, {
        gutter: 24,
        justify: "space-evenly"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 4,
            sm: 4,
            md: 4,
            lg: 4,
            xl: 4
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 20,
            sm: 20,
            md: 20,
            lg: 20,
            xl: 20
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                ($props.estadoDD == 1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Nos encontramos realizando las validaciones de la información suministrada en el \"Registro Único de Clientes\". Pronto recibirás un correo confirmando la finalización del proceso y podrás continuar con la compra de planes. "))
                  : _createCommentVNode("", true),
                ($props.estadoDD == 2)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                      _createElementVNode("b", null, [
                        _createElementVNode("a", {
                          href: $setup.UrlDebidaDiligencia,
                          target: "_self"
                        }, "Aquí", 8, _hoisted_5)
                      ]),
                      _createTextVNode(" podrás actualizar la información suministrada en el \"Registro Único de Clientes\". Ten en cuenta que, si no realizas la actualización, no podrás realizar la compra de planes. ")
                    ]))
                  : _createCommentVNode("", true),
                ($props.estadoDD == 4)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                      _createTextVNode("Gracias por elegir "),
                      _hoisted_7,
                      _createTextVNode(". En este momento, no es posible continuar con la compra de planes para el servicio de "),
                      _hoisted_8,
                      _createTextVNode(". Si deseas obtener más información, puedes comunicarte con nosotros a través del correo electrónico: "),
                      _hoisted_9,
                      _createTextVNode(". ")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}